<template>
  <section class="nian-du-wang-luo-ling-shou">
    <PageBlock title="区域概览">
      <div class="content">
        <div style="text-align: center;color: #fff;font-size: 14px;line-height: 28px">网络零售趋势图</div>
        <div ref="chart" style="width: 100%;height: 260px;"></div>
      </div>
    </PageBlock>
  </section>
</template>

<script>
// 引入 ECharts
import * as echarts from 'echarts';
import PageBlock from "@/components/page-block.vue";
export default {
  name: 'nian-du-wang-luo-ling-shou',
  components: {PageBlock},
  props: {
    yearRetailTrendVoList: Array
  },
  data() {
    return {};
  },
  mounted() {
    this.initChart()
  },
  methods: {
    initChart () {
      const chart = echarts.init(this.$refs.chart);
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          formatter: (params) => {
            let topDiv = '<div>'
            params.forEach((item, index) => {
              if (index === 0) {
                let data = this.yearRetailTrendVoList[item.dataIndex]
                topDiv += `<div>${data.year}年${data.month}月</div>`
              }
              topDiv += `<div>${item.marker}<span>${item.seriesName}: ${item.value}</span></div>`
            })
            topDiv += '<div>'
            return topDiv
          }
        },
        legend: {
          data: ['零售额', '同比增长率'],
          textStyle: {
            color: '#fff'
          },
          right: 0
        },
        grid: {
          left: '40',
          bottom: 20
        },
        xAxis: [
          {
            type: 'category',
            data: this.yearRetailTrendVoList.map(item => item.month),
            axisPointer: {
              type: 'shadow'
            },
            // axisLine: {
            //   show: false
            // }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '万元',
            // min: 0,
            // interval: 50,
            axisLabel: {
              formatter: '{value}',
              color: '#fff'
            },
            splitLine: {
              show: false
            },
          },
          {
            type: 'value',
            name: '',
            // min: 0,
            // interval: 5,
            axisLabel: {
              formatter: '{value}%',
              color: '#fff'
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '零售额',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + '万元';
              }
            },
            data: this.yearRetailTrendVoList.map(item => item.salesAmount)
          },
          {
            name: '同比增长率',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: this.yearRetailTrendVoList.map(item => parseFloat(item.growthRate))
          }
        ]
      };
      // 设置配置项
      chart.setOption(option)
    }
  },
};
</script>

<style scoped>
.nian-du-wang-luo-ling-shou {
}
</style>
